<template>
  <div>
    <div>
      <!--      <SectionHeader></SectionHeader>-->
      <Breadcrumb></Breadcrumb>
    </div>
    <v-container>

      <div>
        <div class="py-3 px-2">
          <div class="py-3">
            <div class="text-no-wrap text-h5">{{ videoInfo.vodName }}</div>
          </div>
          <div class="video-info-class">

            <div class="py-1">
              <v-chip
                  icon="mdi-blinds"
                  @click="chip({
                  vodYear:videoInfo.vodYear
                  })"
              >
                {{ videoInfo.vodYear }}
              </v-chip>
            </div>

            <div class="px-2 py-1">
              <v-chip
                  icon="mdi-blinds"
                  @click="chip({
                  typeName:videoInfo.typeName
                  })"
              >
                {{ videoInfo.typeName }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>


      <v-row>
        <v-col lg="8" cols="12" class="video-col-class">
          <iframe
              :allowfullscreen="true"
              v-if="play.type === 'fq'"
              style="border:none"
              width="100%"
              height="100%"
              v-bind:src="play.url"
          ></iframe>

          <ali-player v-else :url="play.url" :type="play.type" @ready="monitor" ref="player"
                      @completeSeek="saveHistory"
                      @play="saveHistory" @pause="saveHistory"></ali-player>

        </v-col>
        <v-col lg="4" cols="12">
          <v-card height="500">
            <v-card-title max-height="100">
              <div>
                <v-tabs v-model="tabs" @change="tabChange">
                  <v-tab v-for="(item,index) in episodes" :key="index">{{ item.classifyName }}</v-tab>
                </v-tabs>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <div class="px-8 py-3">
              <v-select
                  v-model="current"
                  :items="selections"
                  item-text="name"
                  item-value="index"
                  label="Select"
                  dense
                  solo
              >
              </v-select>
            </div>
            <v-divider></v-divider>
            <v-card-text height="400">
              <div v-if="selections.length !== 0">
                <v-virtual-scroll
                    :bench="benched"
                    :items="selections[current].list"
                    height="300"
                    item-height="50"
                >
                  <template v-slot:default="{ item, index }">
                    <div :key="index" class="pa-2">
                      <v-btn block @click="toPlay(item.eid)"
                             :disabled="index === checked.but && current === checked.selected && tabs === checked.tab">
                        {{ item.name }}
                      </v-btn>
                    </div>
                  </template>
                </v-virtual-scroll>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AliPlayer from '@/components/video/player/AliPlayer.vue'
import {info} from '@/api/resources/video'
import {mapGetters, mapMutations} from "vuex";
// import SectionHeader from "@/components/video/SectionHeader";
import Breadcrumb from '@/components/Breadcrumb'
import {splitUrl} from "@/utils/filters";
import base64 from "@/utils/base64";

export default {
  name: "player",
  data: () => ({
    benched: 0,
    vid: undefined,
    loading: false,
    videoInfo: {},
    selections: [],
    likeList: [],
    play: {},
    current: 0,
    tabs: 0,
    episodes: [],
    checked: {
      tab: 0,
      selected: 0,
      but: 0
    },
    eid: undefined,
    seek: 0,
  }),
  components: {
    'ali-player': AliPlayer,
    // SectionHeader,
    Breadcrumb
  },
  mounted() {
    this.vid = this.$route.query.vid;
    this.eid = this.$route.query.eid
    this.play = {
      ...JSON.parse(new base64().decode(this.$route.query.eid)),
    }
    this.init()
  },
  computed: {
    ...mapGetters(['getNode', 'getHistoryList'])
  },
  methods: {
    ...mapMutations(['setHistory', 'setLoading', 'clearLoading']),
    init() {
      this.setLoading()
      info(this.vid).then(req => {
        let {
          typeName,
          vodDoubanScore,
          vodName,
          vodYear,
          vodPic,
          episodes
        } = req.data.data

        for (let i = 0; i < episodes.length; i++) {
          let list = splitUrl(episodes[i].episodes)
          for (let j = 0; j < list.length; j++) {
            let index = list[j].list.findIndex(item => item.url === this.play.url);
            if (index !== -1) {
              this.checked.tab = i
              this.tabs = i
              this.checked.selected = j
              this.current = j
              this.checked.but = index
            }
          }
        }

        this.episodes = episodes
        this.selections = splitUrl(episodes[this.checked.tab].episodes)

        this.videoInfo = {typeName, vodDoubanScore, vodName, vodYear, vodPic};

        //获取历史记录
        let historyList = this.getHistoryList;

        let history = historyList.find(item => item.vid === this.vid && item.eid === this.eid);

        if (history) {
          let {checked, currentTime} = history;

          this.checked = checked;

          this.current = checked.tab;

          this.seek = currentTime;
        }

      }).finally(() => {
        this.clearLoading()
      })
    },
    monitor(val) {
      if (val) {
        this.$refs.player.seek(this.seek);
        this.setTime = setInterval(() => {
          this.saveHistory();
        }, 1000 * 60);
      }
    },
    saveHistory() {

      let currentTime = Math.floor(this.$refs.player.getCurrentTime());

      if (this.seek !== 0 && currentTime === 0) {
        return;
      }

      let duration = Math.floor(this.$refs.player.getDuration());

      let params = {
        eid: this.eid,
        currentTime: currentTime || 0,
        duration: duration,
        checked: this.checked,
        img: this.videoInfo.vodPic,
        title: this.videoInfo.vodName,
        vid: this.vid,
        time: new Date().getTime()
      };
      console.log('保存历史记录', currentTime);
      //添加历史记录
      this.setHistory(params);
    },
    toPlay(eid) {
      this.$router.push({
        path: '/video/player',
        query: {eid: eid, vid: this.vid}
      })
    },

    chip(param) {
      this.$router.push({
        path: '/video/result',
        query: param
      })
    },
    tabChange(e) {
      this.tabs = e
      this.selections = splitUrl(this.episodes[e].episodes)
    },
  },

  beforeDestroy() {
    this.saveHistory();
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.setTime);
      this.setTime = null;
    });
  },
  destroy() {
    clearInterval(this.setTime);
    this.setTime = null;
  }

}
</script>

<style scoped>
.video-col-class {
  z-index: 1;
}


.v-name-class {
  width: 50%;
}

.v-name-info-class {
  width: 50%;
}

.video-select-class {
  width: 50%;
}

.video-info-class {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}
</style>
